export class TokenManager {
    /**
     * Clean up token from URL
     */
    static cleanupTokenFromUrl(): void {
        const url = new URL(window.location.href);
        url.searchParams.delete('token');
        
        // Remove token from hash if present
        if (url.hash) {
            const hashParams = new URLSearchParams(url.hash.split('?')[1] || '');
            hashParams.delete('token');
            const newHash = url.hash.split('?')[0];
            url.hash = newHash + (hashParams.toString() ? '?' + hashParams.toString() : '');
        }

        // Update URL without reload
        window.history.replaceState({}, '', url.toString());
    }
}
